<template>
  <vcv-footer type="landing"/>
</template>

<script>

  import vcvFooter from './default.vue';

  export default {
    name: 'footer-main',
    components: {vcvFooter}
  }
</script>